import styled from 'styled-components';

export const StyledLogo = styled.div`
  width: 50px;
  height: auto;
  flex-shrink: 0;
`;